import { AxiosResponse } from "axios";
import { Http } from "../../Utils/Http";
import { IResponse } from "../Interfaces/Base/IResponse";

export interface ITermoAPI {
  fetchTermo(nome: string): Promise<AxiosResponse<string>>;
}

class TermoAPI implements ITermoAPI {
  async fetchTermo(nome: string): Promise<AxiosResponse<string>> {
    const axios = await Http.axios();
    const response = axios.get<string>(`/api/Privacy/termo/${nome}`);
    return response;
  }
}

const instance = new TermoAPI();

export default instance;
